/**
 * Presentational component for editable profile name and email fields.
 */

import { TextInput } from "risa-oasis-ui_v2";
import type { ProfileDetails } from "../types";

/** Props for {@link ProfileInfoFields}. */
interface ProfileInfoFieldsProps {
  /** Current profile field values */
  profileDetails: ProfileDetails;
  /** Called when first or last name input changes */
  onValueChange: (data: { name: string; value: string }) => void;
}

/**
 * Renders the read-only email and editable first/last name fields on the profile page.
 */
export function ProfileInfoFields({
  profileDetails,
  onValueChange,
}: ProfileInfoFieldsProps) {
  return (
    <>
      <div className="profile--container__body--firstName">
        <TextInput
          id="profile-first-name"
          label="First Name"
          defaultValue={profileDetails.firstName}
          onChange={(e: { name: string; value: string }) => {
            onValueChange(e);
          }}
        />
      </div>
      <div className="profile--container__body--lastName">
        <TextInput
          id="profile-last-name"
          label="Last Name"
          defaultValue={profileDetails.lastName}
          onChange={(e: { name: string; value: string }) => {
            onValueChange(e);
          }}
        />
      </div>
      <div className="profile--container__body--email">
        <TextInput
          id="profile-email"
          label="Email"
          defaultValue={profileDetails.email}
          readOnly={true}
        />
      </div>
    </>
  );
}
